import React from 'react';

function createReactRenderDecorator(onRender) {
    function wrappedRenderFactory(originalRender) {
        return function wrappedRender() {
            const renderedComponent = originalRender.bind(this, arguments).apply();
            return React.isValidElement(renderedComponent) ? onRender.call(this, renderedComponent) : null;
        };
    }

    return function decorator(target) {
        if(typeof target.prototype.render === 'undefined')
            throw new Error('Component must have a render function defined.');

        Object.defineProperty(target.prototype, 'render', {
            value: wrappedRenderFactory(target.prototype.render)
        });
    }
}

export { createReactRenderDecorator }
